import { extractImagePath, stripImagePathFromText } from './simulationQuestionPresentation';

export type PrintablePart = `R${number}` | `W${number}` | 'READING' | 'WRITING' | 'MATH';
export type PartFilter = 'ALL' | PrintablePart;

export const getPrintablePart = (part: string, bankVersion?: string): PrintablePart | null => {
  const normalized = String(part || '').trim().toUpperCase();
  if (bankVersion === 'CSCA' || normalized === 'MATH') return 'MATH';
  if (/^[RW]\d+$/.test(normalized) || normalized === 'READING' || normalized === 'WRITING') return normalized as PrintablePart;
  return null;
};

export const getPrintableParts = (items: Array<{ printablePart: PrintablePart }>) =>
  Array.from(new Set(items.map(item => item.printablePart))).sort((a, b) => a.localeCompare(b, 'en', { numeric: true }));

export const getSectionTitle = (part: PrintablePart) =>
  part === 'MATH' ? 'CSCA Math' : `${part.startsWith('R') ? 'Reading' : 'Writing'} · ${part}`;

export const getSectionHelp = (part: PrintablePart) =>
  part === 'MATH' ? 'Multiple choice questions' : part.startsWith('R') ? 'Reading questions' : 'Writing questions';

export const resolveWrongImage = (value?: string | null) => {
  const path = extractImagePath(value);
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  return `${BACKEND_URL.replace(/\/$/, '')}/media/${path.replace(/^\/?(?:api\/)?media\//, '').replace(/^\//, '')}`;
};

export const wrongTextWithoutImage = stripImagePathFromText;
export const escapeWrongHtml = (value: string) => String(value || '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

export const formatWrongPrintText = (value: string) => {
  const image = resolveWrongImage(value);
  const text = image ? wrongTextWithoutImage(value) : value;
  return escapeWrongHtml(String(text || '').replace(/\r\n/g, '\n')).replace(/\n/g, '<br />')
    + (image ? `<img src="${escapeWrongHtml(image)}" alt="Question image" style="display:block;max-width:100%;max-height:240px;object-fit:contain" />` : '');
};
